export function treatRequestRecursive(obj: any): any {
	if (obj === null || obj === undefined || obj === '') {
		return undefined;
	}

	if (Array.isArray(obj)) {
		return obj
			.map(item => treatRequestRecursive(item))
			.filter(item => item !== undefined);
	}

	if (typeof obj !== 'object') {
		return obj;
	}

	if (obj.constructor === Object) {
		const cleanedEntries = Object.entries(obj)
			.map(([key, value]) => {
				const cleanedValue = treatRequestRecursive(value);
				return cleanedValue !== undefined ? [key, cleanedValue] : undefined;
			})
			.filter((entry): entry is [string, any] => entry !== undefined);

		return cleanedEntries.length > 0
			? Object.fromEntries(cleanedEntries)
			: undefined;
	}

	return obj;
}

export function treatRequest<T extends object>(obj: T): Partial<T> {
	const result = treatRequestRecursive(obj);
	return result === undefined ? {} : result;
}
